import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment' ;
import axios from 'axios';
import { DatePickerInput } from 'rc-datepicker';
import { Field, Checkbox } from '../Common'

export class AssistanceAgreementForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            firstName: props.data.beneficiaryFirstname ? props.data.beneficiaryFirstname : '',
            name: props.data.beneficiaryName ? props.data.beneficiaryName : '',
            date: props.data.contractStartDate ?  props.data.contractStartDate : '', 
            savePersonalData: "0",
            implementAssistanceServices: "0",
            preventMemoryCharge: "0",
            autorisationStockageDonnees: props.data.autorisationStockageDonnees,
            contractNumber: props.data.contractNumber,
            uploadStatus: false,
            authorisationLabel: "J’autorise " + this.props.partenaireData.marqueAllianzPartners + " et AWP France SAS à collecter, stocker et utiliser des données nominatives sensibles me concernant (ex : croyances religieuses).",
            error: {
                name: '',
                date: '',
                address: '',
                zipCode: '',
                city: '',
            }
        }
        this.handleChange = this.handleChange.bind(this);		
    }

    handleChange(value) {
        this.setState({ date : value })
    }

    dateOnChange = (jsDate, dateString) => {
        let obj = {}
        obj.date = (dateString === 'Invalid date') ? 'is-invalid' : ''
        this.setState(prevState => ({
            date: dateString,
            error: {
                ...prevState.error,
                ...obj
            }
        }));
    }

    handleOnChange(key, e) {
        let value = e.target.value;
        if (e.target.type === "checkbox")
            value = e.target.checked ? true : false;
        this.setState(() => ({ [key]: value }));
    }
    onSubmit = (e) => {
        e.preventDefault();
        let obj = {};
        obj.name = (!this.state.name) ? ' is-invalid' : '';
        obj.firstName = (!this.state.firstName) ? ' is-invalid' : '';
        obj.date = (!this.state.date) ? ' is-invalid' : '';

        this.setState(prevState => ({
            error: {
                ...prevState.error,
               ...obj
            }
        }))
        if (!obj.name && !obj.firstName && !obj.date)
            this.props.onSubmit({
                firstName: this.state.firstName,
                name: this.state.name,
                date: moment(this.state.dateNaissance).format(), // this.state.dateNaissance,
                savePersonalData: this.state.savePersonalData,
                implementAssistanceServices: this.state.implementAssistanceServices,
                preventMemoryCharge: this.state.preventMemoryCharge,
                autorisationStockageDonnees: this.state.autorisationStockageDonnees,
                contractNumber: this.state.contractNumber
            });
    }

    render() {
        return (
            <div className="container">
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-sm-5">
                        <img src='/images/b1-page.png' alt="image profil" className="_lg" />
                        <img src='/images/b1-page-sm.png' alt="image profil" className=" _sm" />
                    </div>
                    <div className="col-sm-7 form-container top-form">
                        <Field
                            label="Nom *"
                            type="text"
                            ////placeholder="DUPOND"
                            _className={"form-control  " + this.state.error.name}
                            value={this.state.name}
                            onChange={this.handleOnChange.bind(this, "name")}
                            error={this.state.error.name}
                            readOnly = {true}
                        />
                        <Field
                            label="Prénom *"
                            type="text"
                            ////placeholder="ALAIN"
                            _className={"form-control  " + this.state.error.firstName}
                            value={this.state.firstName}
                            onChange={this.handleOnChange.bind(this, "firstName")}
                            error={this.state.error.firstName}
                            readOnly = {true}

                        />
                        <Field
	                        label="Numéro de contrat *"
	                        type="text"
	                        ////placeholder="ALAIN"
	                        _className={"form-control  " + this.state.error.contractNumber}
	                        value={this.state.contractNumber}
	                        onChange={this.handleOnChange.bind(this, "contractNumber")}
	                        error={this.state.error.contractNumber}
	                        readOnly = {true}
	
	                    />
                        <div className="form-group">
                        <label>Date d'effet du contrat *</label>
                          <DatePickerInput
                                onChange={this.dateOnChange}
                                value={this.state.date}
                                maxDate={moment()}
                                className={'custom-datepicker readonly' + this.state.error.date}
                                showOnInputClick={true}
                                iconClassName='cal-icon'
                                locale = 'fr'
                            />
                        {this.state.error.date &&
                            <div className="invalid-feedback invalid-date">
                                Le champ Date d'effet du contrat *  est obligatoire
                                </div>
                        }
                        </div>
                        
                        <div className="required-txt"> * Champs obligatoires</div>
                        
                        <Checkbox 
                        type="checkbox"
                        _id="_ch1"
                        label = {this.state.authorisationLabel}
                        onChange={this.handleOnChange.bind(this, "autorisationStockageDonnees")}
                        checked={this.state.autorisationStockageDonnees}
                   		value={this.state.autorisationStockageDonnees}
                        />
                        
                    </div>
                        
                    <div className="col-sm-12 form-container align-center">
	                    <div className="button-container">
	                    	<button onClick={this.props.annuler} className="btn btn-outline-primary">ANNULER</button>
			                <button type="submit" className="btn btn-primary">ENREGISTRER</button>
			            </div>
                    </div>
                    
                </div>
            </form>
			</div>
        )
    }
}

const mapStateToProps = state => ({
    partenaireData: state.partenaireData
})

export default connect(mapStateToProps, undefined)(AssistanceAgreementForm);


// WEBPACK FOOTER //
// ./src/components/AssistanceAgreementPage/AssistanceAgreementForm.js